// Third Party Library
import { useDispatch } from "react-redux";

// Constants Library
import { ROOT_CONSTANT, TEMPLATE } from "../../../../constants";

// Components Library
import {
  BtnSubmit,
  ButtonModal,
  TablePagination,
} from "../../../../components";

// Redux Acions
import * as REDUX_ACTION from "../../../../services/redux/actions";

// Styles Library
import classes from "../../../../pages/index.module.css";

const { icon_filter } = ROOT_CONSTANT.IMG.ICON;
const { MODAL_ACTION } = TEMPLATE.MODAL;

const HeaderBilling = (props) => {
  const {
    setIsModalOpen,
    pageSize,
    setPageSize,
    filteredDataCount,
    handlePaginatedDataChange,
    current,
    setCurrent,
    tabKey,
    data,
    user,
    selectedRow,
    selectedRowKeys,
    messageApi,
  } = props;

  const dispatch = useDispatch();
  
  const bulkPublish = () => {
    messageApi.open({
      type: "loading",
      content: "Bulk Publish...",
      duration: 0,
    })

    dispatch(
      REDUX_ACTION.v1_billing.bulk_publish_billing_request(
        { billids: selectedRowKeys, updatedBy: user.memid },
        () => {
          messageApi.destroy();
        }
      )
    );
  }
 
  const isBulkPublishEnabled =
    selectedRow.length > 0 && selectedRow.every(row => row.status === 1);

  return (
    <>
      <div className={classes.headerPage}>
        <div className={classes.headerWrap}>
          <div className={classes.headerSubStart}>
            <BtnSubmit
              display="inline-block"
              text="Filter"
              bgColor="transparent"
              color="black"
              padding="9px 18px"
              marginTop="2px"
              fontWeight="700"
              border="1px solid #DDDDDD"
              outline="#DDDDDD"
              onClick={() => setIsModalOpen(true)}
              showIcon={true}
              icon={icon_filter}
              icon_alt={"filter"}
            />
          </div>
          <TablePagination
            tabKey={tabKey}
            data={data}
            filteredDataCount={filteredDataCount}
            onPaginatedDataChange={handlePaginatedDataChange}
            pageSize={pageSize}
            setPageSize={setPageSize}
            current={current}
            setCurrent={setCurrent}
          />
        </div>
        {user.uroleid === "A" && (
          <div className={classes.headerSubEnd}>
            <ButtonModal
              setmodal={MODAL_ACTION.confirmation_bulk_publish_billing_list}
              style={{
                height: "46px",
                marginRight: "5px",
                border: "1px solid #0E2483",
                color: "white",
                backgroundColor: "#0E2483",
              }}
              data={selectedRow}
              onClick={() => bulkPublish()}
              disabled={!isBulkPublishEnabled} 
            >
              Bulk Publish
            </ButtonModal>
          </div>
        )}
      </div>
    </>
  );
};

export default HeaderBilling;
